export default "__VITE_ASSET__bfb3bb9a__"